import React, { useState } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function ChangeAdminPassword() {
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!form.oldPassword || !form.newPassword || !form.confirmPassword) {
      setMessage("All fields are required");
      return;
    }

    if (form.newPassword.length < 4) {
      setMessage("New password must be at least 4 characters");
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      setMessage("New password and confirm password do not match");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/auth/change-password`, {
        method: "POST",
        headers: authHeaders({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          oldPassword: form.oldPassword,
          newPassword: form.newPassword,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to change password");
      }

      setMessage("Password changed successfully");

      setForm({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      console.error("Change password error:", err);
      setMessage(err.message || "Failed to change password");
    }
  };

  return (
    <div style={{ maxWidth: 520 }}>
      <h2>Change Password</h2>

      <p style={{ color: "#555" }}>
        Change your own login password. This is available for both FPO Admin and
        Super Admin.
      </p>

      {message && (
        <div
          style={{
            marginBottom: 16,
            padding: 10,
            background: "#f5f5f5",
            border: "1px solid #ddd",
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 12 }}>
          <label>Old Password *</label>
          <input
            name="oldPassword"
            type="password"
            value={form.oldPassword}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>New Password *</label>
          <input
            name="newPassword"
            type="password"
            value={form.newPassword}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label>Confirm New Password *</label>
          <input
            name="confirmPassword"
            type="password"
            value={form.confirmPassword}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </div>

        <button
          type="submit"
          style={{
            padding: "9px 14px",
            background: "#1976D2",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          Change Password
        </button>
      </form>
    </div>
  );
}